import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

import { LayoutContext } from '../../../context';


export const AdsContext = createContext(null);
export const useAds = () => useContext(AdsContext) || {};


const newSessionId = () => {
    try {
        if (window.crypto?.randomUUID) return window.crypto.randomUUID().replace(/-/g, '').slice(0, 32);
    } catch (e) { /* старый браузер */ }
    return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
};


/**
 * Общий контекст рекламного слоя.
 *
 * Держит идентификатор сессии — по нему сервер отсекает повторный показ
 * одного креатива в рамках одного просмотра ленты. Колода при сбросе
 * начинает новую сессию, иначе после «начать заново» пользователь
 * не увидит ни одного объявления.
 */
export default function AdsProvider({ children, disabled = false }) {
    const layout = useContext(LayoutContext) || {};
    const [sessionId, setSessionId] = useState(newSessionId);
    const inflight = useRef(new Map());

    const resetSession = useCallback(() => setSessionId(newSessionId()), []);

    const value = useMemo(() => ({
        token: layout.token || null,
        sessionId,
        resetSession,
        disabled,
        inflight: inflight.current,
    }), [layout.token, sessionId, resetSession, disabled]);

    return <AdsContext.Provider value={value}>{children}</AdsContext.Provider>;
}